import { render, staticRenderFns } from "./LinkedinLoginButton.vue?vue&type=template&id=6994acea&scoped=true&"
import script from "./LinkedinLoginButton.vue?vue&type=script&lang=js&"
export * from "./LinkedinLoginButton.vue?vue&type=script&lang=js&"
import style0 from "./LinkedinLoginButton.vue?vue&type=style&index=0&id=6994acea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6994acea",
  null
  
)

export default component.exports